import React, { useState, useEffect, useRef } from 'react';
import { getAvatarColorClass } from '../../../../util/util-helpers';

export default function CommentComposer({ value, onChange, onSubmit, onCancel, userName, translate }) {
    const [isExpanded, setIsExpanded] = useState(() => false);
    const actionsRef = useRef(null);

    useEffect(() => {
        if (isExpanded && actionsRef.current) {
            actionsRef.current.scrollIntoView({behavior: 'smooth', block: 'nearest'});
        }
    }, [isExpanded]);

    const initials = (userName || '')
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(word => word[0].toUpperCase())
        .join('');

    const avatarColor = getAvatarColorClass(initials);

    return (
        <div className="flex gap-3">
            <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold text-inverse ${avatarColor}`}>
                {initials}
            </div>

            <div className="min-w-0 flex-1">
                <textarea
                    rows={isExpanded ? 3 : 1}
                    value={value}
                    onChange={e => onChange('TaskComment', e.target.value)}
                    onFocus={() => setIsExpanded(true)}
                    placeholder={translate('placeholder.add_comment')}
                    className="w-full resize-none rounded-md border border-tm-gray-300 bg-inverse px-3 py-2 text-sm placeholder:text-tm-gray-400 focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/30"
                />

                {isExpanded && (
                    <>
                        <div className="mt-2 flex gap-2">
                            <button
                                type="button"
                                onClick={onSubmit}
                                className="rounded-btn bg-primary px-3 py-1.5 text-sm font-medium text-inverse hover:bg-primary-shade focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1"
                            >
                                {translate('btn.save')}
                            </button>

                            <button
                                type="button"
                                onClick={() => { onCancel(); setIsExpanded(false); }}
                                className="rounded-btn px-3 py-1.5 text-sm font-medium text-tm-gray-600 hover:bg-tm-gray-100"
                            >
                                {translate('btn.cancel')}
                            </button>
                        </div>

                        <div ref={actionsRef} className="h-4" />
                    </>
                )}
            </div>
        </div>
    );
}
